import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface FamilyRecord {
  full_name?: string;
  relation?: 'first' | 'second' | 'other' | '';
}

@Component({
  selector: 'app-family-input',
  templateUrl: './family-input.component.html',
  styleUrls: ['./family-input.component.scss'],
})
export class FamilyInputComponent implements OnInit {
  @Input() family: FamilyRecord[] = [];
  @Input() errors = {};
  @Output() familyChange = new EventEmitter<FamilyRecord[]>();

  constructor() { }

  ngOnInit() {
  }

  addNewMember() {
    this.family.push({ full_name: '', relation: '' });
  }

  removeMember(index: number) {
    this.family.splice(index, 1);
    this.familyChange.emit(this.family);
  }

  onChange(index: number, field: string, val: any) {
    if (!this.family[index]) return;

    this.family[index][field] = val;
    this.familyChange.emit(this.family);
  }
}



// WEBPACK FOOTER //
// ./src/app/accounts/family-input/family-input.component.ts